import { createSlice } from "@reduxjs/toolkit";
import { deleteDepartment } from "../thunks/deleteDepartmentThunk";

const deleteDepartmentSlice = createSlice({
  name: "department",
  initialState: {
    status: "idle", // 'idle' | 'loading' | 'success' | 'error'
    error: null,
    message: null,
  },
  reducers: {
    resetDeleteDepartmentStatus: (state) => {
      state.status = "idle";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(deleteDepartment.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(deleteDepartment.fulfilled, (state, action) => {
        state.message = action.payload.msg;
        state.status = "success";
        state.error = null;
      })
      .addCase(deleteDepartment.rejected, (state, action) => {
        state.status = "error";
        state.error = action.payload;
      });
  },
});

export const { resetDeleteDepartmentStatus } = deleteDepartmentSlice.actions;
export default deleteDepartmentSlice.reducer;
